import css from './SearchFilter.module.css';

function SearchFilter({ filter, setFilter }) {
    return (
        <input
            type="text"
            placeholder="Filter results..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={css.filterInput}
            //box-shadow: 0 0 8px 0 #54b5f7;
            // style={{color: isError ? "red" : "black"}}
        />
    );
}

export default SearchFilter;
